import React, { ChangeEvent, useEffect, useState } from "react";
import { apiGet, apiSaveContact } from "../../services/service";
import "./sign-up.css";
import {
  TextBox,
  RadioGroup,
  RadioButton,
  Button,
  TextArea,
  Select,
  Card,
  useToast,
  InlineNotification,
} from "@veneer/core";
import { Container } from "react-bootstrap";
import { GET_Countries } from "../../services";
import { useNavigate } from "react-router-dom";
import { addressRegex, cityRegex, getValidatedNumberInput, isValidEmail, isValidField, isValidPhoneNumber } from "../../utils";
import { Trans, useTranslation } from "react-i18next";
import { useAppDispatch } from "@store/hooks";
import { setLoading } from "@store/reducers/loadingSlice";
import { toast } from "react-toastify";

interface FormDatas {
  firstname: string;
  lastname: string;
  email: string;
  country: string;
  city: string;
  province: string;
  addressLine1: string;
  postalCode: string;
  company: string;
  code: string;
  phoneNumber: string;
  companyAddress: string;
  userType: string;
}

interface ErrorState {
  [key: string]: string;
}
interface ErrorStateCompany {
  [key: string]: string;
}

interface FormState {
  [key: string]: string;
}

type FormData = {
  [key: string]: string;
};
type FormFields =
  | "firstname"
  | "lastname"
  | "firstname2"
  | "email"
  | "country"
  | "city"
  | "province"
  | "addressLine1"
  | "code"
  | "postalCode";
type FormErrors = Record<FormFields, string>;
const SignUp = ({ shape = "sharp" }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  if (localStorage.getItem("signupcompleted") === "true") {
    navigate("/");
  }
  const [countryLabel, setCountryLabel] = React.useState(
    t("HPI.ProfilePage.cs.SelectCountry", {
      defaultValue: "Select Country/Region",
    })
  );
  const [countryAll, setCountryAll] = React.useState([]);
  const [optionCountry, setOptionCountry] = React.useState([]);
  const [codeLabel, setCodeLabel] = React.useState(
    t("HPI.ProfilePage.cs.SelectCountryCode", { defaultValue: "Code" })
  );
  const [codeAll, setCodeAll] = React.useState([]);
  const [optionCode, setOptionCode] = React.useState([]);
  const [optionCodeValue, setOptionCodeValue] = React.useState<any[]>([]);
  const [userType, setUserType] = useState<string | null>(null);
  const [isFormValid, setIsFormvalid] = useState<boolean>(true);

  const [isShowSingle, setIsShowSingle] = useState<boolean>(false);
  const [isShowCompany, setIsShowCompany] = useState<boolean>(false);
  const { addToast } = useToast();
  const [errors, setErrors] = useState<ErrorState>({});
  const [errorState, setErrorState] = useState<ErrorState>({});
  const [FlaglblCompanySuccessMessage, setFlaglblCompanySuccessMessage] =
    useState<boolean>(false);
  const [lblCompanySuccessMessage, setlblCompanySuccessMessage] =
    useState<string>("");
  const [lblServerErrorFlag, setlblServerErrorFlag] = useState<boolean>(false);
  const [lblServerError, setlblServerError] = React.useState("");

  useEffect(() => {
    async function fetchMyAPI() {
      try {
        const res = await apiGet(GET_Countries);
        if (res.data && res.data.CountryList.length > 1) {
          const Contryotn = JSON.parse(res.data.CountryList).map(
            (items: any, index: any) => {
              return { value: items.Key, label: items.Value };
            }
          );
          const codeObj = JSON.parse(res.data.CountryList).map(
            (items: any, index: any) => {
              return {
                value: items.Key,
                label: `${items.CountryCode} ${items.ShortCode}`,
              };
            }
          );
          setOptionCountry(Contryotn);
          setCountryAll(Contryotn);
          setOptionCode(codeObj);
          setCodeAll(codeObj);
        }
      } catch (error) {
        console.error("Error fetching recent cases:", error);
      }
    }
    fetchMyAPI();
  }, []);
  const onSearchCountry = (value: any) => {
    const filteredOptions = countryAll.filter((item: any) =>
      item.label.toLowerCase().includes(value.toLowerCase())
    );
    setOptionCountry(filteredOptions);
  };
  const onSearchCode = (value: any) => {
    const filteredOption = codeAll.filter((item: any) =>
      item.label.toLowerCase().includes(value.toLowerCase())
    );
    setOptionCode(filteredOption);
  };

  const [formData, setFormdata] = useState<FormData>({
    firstname: "",
    lastname: "",
    email: "",
    country: "",
    city: "",
    province: "",
    addressLine1: "",
    postalCode: "",
    company: "",
    code: "",
    phoneNumber: "",
    companyAddress: "",
    userType: "",
  });

  const handleUserTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setUserType(event.target.value);
    onClear("country");
    setErrorState({});
  };
  useEffect(() => {
    if (userType === "company") {
      setFormdata({
        userType: "100000001",
        firstname: "",
        lastname: "",
        email: "",
        country: "",
        city: "",
        province: "",
        addressLine1: "",
        postalCode: "",
        company: "",
        code: "",
        phoneNumber: "",
        companyAddress: "",
      });

      //console.log("Company selected");
    } else if (userType === "individual") {
      setFormdata({
        userType: "100000000",
        firstname: "",
        lastname: "",
        email: "",
        country: "",
        city: "",
        province: "",
        addressLine1: "",
        postalCode: "",
        company: "",
        code: "",
        phoneNumber: "",
        companyAddress: "",
      });
      // console.log("individual selected");
    }
  }, [userType]);

  //console.log(formData, "FormData");
  const handleInputChanges = (
    value: string,
    event: ChangeEvent<HTMLInputElement>
  ) => {
    const { id, name } = event.target;

    if (id === "phoneNumber") {
      value = value.replace(/[^0-9]/g, "");
    }
    setFormdata((prev) => ({ ...prev, [id]: value }));
    if (['phoneNumber', 'email'].includes(name)) {
      setErrorState((prevState) => ({
        ...prevState,
        [name]: '',
      }));

      setErrors((prevState) => ({
        ...prevState,
        [name]: '',
      }));
      
    } else {
      validateField(name, value);
    }

    // validateField(name, value);
  };

const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if(value){
      validateField(name, value);
    }
  };


  const handleTextAreaInput = (
    value: string,
    e: ChangeEvent<HTMLTextAreaElement>
  ) => {
    const { id, name } = e.target;
    setFormdata((prev) => ({ ...prev, [id]: value }));
    validateField(name, value);
  };
  const validatePhoneNumber = (phoneNumber: string): boolean => {
    const numberRegex = /^\d{10,11}$/;
    return numberRegex.test(phoneNumber);
  };

  const validateField = (name: string, value: string) => {
    let error = "";
    if (!value) {
      error = t('HPI.ErrorMessage.RequiredFields',{defaultValue:'This field is required.'});
    }
    
    // let firstnamereg = /^[\p{L}\s]+$/u;
    // if (name === "firstname" && isValidField(value)) {
    //   error = t('HPI.ErrorMessage.InvalidFirstName',{defaultValue:'Invalid First Name'});
    // }
    // if (name === "lastname" && isValidField(value)) {
    //   error = "Invalid Last Name";
    // }

    if (name === "email" && value && !isValidEmail(value)) {
      error = t('HPI.ErrorMessage.InvalidEmailFormat',{defaultValue:'Invalid email format'});
    }

    if (name === "phoneNumber" && value && !isValidPhoneNumber(value)) {
      error = t('HPI.ErrorMessage.InvalidNumber',{defaultValue:'Phone number must be 8-15 digits long and contain only numbers.'});
    }
    // if (name === "addressLine1" && isValidField(value)) {
    //   error = "Please add a valid address.";
    // }
    // if (name === "country") {
    //   if (!value) {
    //     error = t('HPI.ErrorMessage.RequiredFields',{defaultValue:'This field is required.'});
    //   }
    // }
    // let cityReg = /^(?!NA$|N\/A$)[\p{L} -]+$/u;
    // if ((name === "city" || name === "province") && isValidField(value)) {
    //   error = "Please add a valid address.";
    // }
    // const companyregex = /^(?!.*\b(?:NA|N\/A)\b)[A-Za-z0-9 &\/#,_-]+$/;
    // if (name === "company" && isValidField(value)) {
    //   error = "Please add a valid name.";
    // }
    setErrorState((prevState) => ({
      ...prevState,

      [name]: error,
    }));
  };

  const validateForms = (formData: FormData, userType: string | null) => {
    const newErrorState: ErrorState = {};
    const requiredFields =
      userType === "company"
        ? [
            "firstname",
            "lastname",
            "email",
            "country",
            "city",
            "province",
            "addressLine1",
            // "code",
            "postalCode",
            "company",
            // "country",
            "phoneNumber",
            "companyAddress",
          ]
        : [
            "firstname",
            "lastname",
            "email",
            "country",
            "city",
            "province",
            "addressLine1",
            "postalCode",
          ];

    requiredFields.forEach((field) => {
      if (!formData[field]?.trim()) {
        errorState[field] = t('HPI.ErrorMessage.RequiredFields',{defaultValue:'This field is required.'});
      }
    });
    return errorState;
  };

  const selectedOptionCode = (event: any) => {
    let field = "code";
    const value = event.value;
    setOptionCodeValue([value]);
    if (event.value.length) setCodeLabel("");
    else
      setCodeLabel(
        t("HPI.ProfilePage.cs.SelectCountryCode", { defaultValue: "Code" })
      );
    setFormdata({ ...formData, [field]: value });
    if (value) {
      setErrors((errors: any) => ({
        ...errors,
        code: "",
      }));
    } else {
      setErrors((errors: any) => ({
        ...errors,
        code: "Code is Requiredq",
      }));
    }
  };
  const selectedOptionCountry = (event: any) => {
    let field = "country";
    const value = event.value;
    const { id, name } = event.value;
    setFormdata((prev) => ({ ...prev, [id]: value }));
    setOptionCodeValue([value]);

    if (event.value.length) setCountryLabel("");
    else
      setCountryLabel(
        t("HPI.ProfilePage.cs.SelectCountry", {
          defaultValue: "Select Country/Region",
        })
      );
    setFormdata({ ...formData, [field]: value, ["cname"]: event.label });
    if (value) {
      // clearError(errors.country)
      setErrors((errors: any) => ({
        ...errors,
        country: "",
      }));
      setErrorState((errors: any) => ({
        ...errors,
        country: "",
      }));
    }
  };

  const formHandleOnSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    const newErrors = validateForms(formData, userType);
    setErrorState(newErrors);
    setErrors(newErrors);
    const isValid = Object.values(newErrors).every((error) => error === "");
    if (!isValid) {
      return;
    }

    try {
      setIsFormvalid(false);
      dispatch(setLoading(true));
      localStorage.setItem("signupcompleted", "false");
      setIsFormvalid(false);
      setlblServerErrorFlag(false);
      setFlaglblCompanySuccessMessage(false);
      const res = await apiSaveContact(formData);
      if (res.status === 200) {
        const { lblCompanySuccessMessage, lblServerError, lblSuccessMessage } =
          res.data;
        dispatch(setLoading(false));
        const element = document.getElementById("error-msg");
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
        if (
          lblCompanySuccessMessage.length > 15 &&
          lblCompanySuccessMessage !== ""
        ) {
          setFlaglblCompanySuccessMessage(true);
          setlblCompanySuccessMessage(lblCompanySuccessMessage);
          return false;
        }

        if (lblServerError) {
          setIsFormvalid(true);
          setlblServerErrorFlag(true);
          setlblServerError(lblServerError);
          return false;
        }

        if (lblSuccessMessage) {
          localStorage.setItem("signupcompleted", "true");
          localStorage.setItem("lblSuccessMessage", lblSuccessMessage);
          const InvCode = lblSuccessMessage;
          if (InvCode) {
            const langPath = (window as any).langPath
              ? `/${(window as any).langPath}`
              : "/en-US";
            window.open(
              `https://${window.location.host}${langPath}/register?invitation=${InvCode}`,
              "_self"
            );
          }
        } else if (lblCompanySuccessMessage) {
          localStorage.setItem("signupcompleted", "true");
        }
        if (localStorage.getItem("signupcompleted") === "true") {
          navigate("/");
        }
      } else {
        dispatch(setLoading(false));
      }
      if (lblServerError || lblServerError.trim() === "") {
        const warnings = res.lblWarningMessages || res.lblWarningMessages;
        if (warnings) {
          if (warnings.lblWarningMessages.PrimayContactWarning) {
            toast.warning(`Primary Contact Warning: ${warnings.lblWarningMessages.PrimayContactWarning}`);
          }
          if (warnings.lblWarningMessages.AlternateContactWarning) {
            toast.warning(`Alternate Contact Warning: ${warnings.lblWarningMessages.AlternateContactWarning}`);
          }
          if (warnings.lblWarningMessages.EquipContactWarning) {
            toast.warning(`Equipment Contact Warning: ${warnings.lblWarningMessages.EquipContactWarning}`);
          }
          if (warnings.lblWarningMessages.ShippingContactWarning) {
            toast.warning(`Shipping Contact Warning: ${warnings.lblWarningMessages.ShippingContactWarning}`);
          }
        }
      }
    } catch (error) {
      dispatch(setLoading(false));
      setIsFormvalid(true);
    }
  };

  const onClear = (field: string) => {
    setCountryLabel(
      t("HPI.ProfilePage.cs.SelectCountry", {
        defaultValue: "Select Country/Region",
      })
    );
    setCodeLabel(
      t("HPI.ProfilePage.cs.SelectCountryCode", { defaultValue: "Code" })
    );
    setOptionCodeValue([]);
    setFormdata((formData) => ({
      ...formData,
      [field]: "",
    }));

    setErrors((errors: any) => ({
      ...errors,
      [field]: `${field.charAt(0).toUpperCase() + field.slice(1)} is required `,
    }));
  };

  const clearError = (field: string) => {
    setErrors((prevErrors: any) => {
      if (prevErrors[field]) {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[field];
        return updatedErrors;
      }
      return prevErrors;
    });
  };

  function setUserChange(value: string): void {
    if (value === "0") {
      setIsShowCompany(true);
      setIsShowSingle(false);
    } else if (value === "1") {
      setIsShowCompany(false);
      setIsShowSingle(true);
    }
  }

  return (
    <>
      <Container fluid className="sign-up-page">
        <div className="info-msg-box text-center">
          <p
            className="body-regular "
            dangerouslySetInnerHTML={{
              __html: t("Home/Notification", {
                defaultValue: `<p>Looking for assistance with your Poly devices?  Contact Poly Customer Support - <a href=\"https://www.poly.com/us/en/support\">Click Here</a></p>`,
              }),
            }}
          ></p>
        </div>
        <Card
          background="filled"
          border="outlined"
          className="Form-container"
          content={
            <div>
              <div className="head">
                <h5 className="subtitle-regular">
                  {t("HPI.OpenContactCreate.signup", {
                    defaultValue: "Sign up for new user",
                  })}
                </h5>
              </div>
              <div
                className="tab-pane fade show active text-left"
                id="pills-home"
                role="tabpanel"
                aria-labelledby="pills-home-tab"
              >
                <div className="form-content">
                  <div className="row new-case-row1 m-1">
                    <h6
                      className="body-regular"
                      dangerouslySetInnerHTML={{
                        __html: t("HPI.OpenContactCreate.PageDescription1", {
                          defaultValue: `<p>&nbsp;MyHPSupport is for business customers only.For home users needing support, <a target="_blank" href="https://support.hp.com/us-en/contact-hp"><i>Contact Support</i></a>.</p>`,
                        }),
                      }}
                    ></h6>

                    <div id="error-msg">
                      {FlaglblCompanySuccessMessage ? (
                        <div className="newCompany">
                          <InlineNotification
                            actionPlacement="top"
                            closeButton={false}
                            customStyle={{ width: "100%" }}
                            title={
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: lblCompanySuccessMessage,
                                }}
                              ></div>
                            }
                            type="positive"
                          />
                        </div>
                      ) : (
                        ""
                      )}
                      {lblServerErrorFlag ? (
                        <InlineNotification
                          actionPlacement="top"
                          closeButton={false}
                          customStyle={{ width: "100%" }}
                          title={
                            <div
                              className="red-message"
                              dangerouslySetInnerHTML={{
                                __html: lblServerError,
                              }}
                            ></div>
                          }
                          type="negative"
                        />
                      ) : (
                        ""
                      )}
                    </div>

                    <h5 className="body-regular instruction-heading">
                      {t("HPI.OpenContactCreate.SignUpheading", {
                        defaultValue:
                          "Please select one of the following options:",
                      })}{" "}
                      <span style={{ color: "red" }}> *</span>
                    </h5>
                    <h5>
                      <RadioGroup
                        alignment="vertical"
                        id="radio-id"
                        name="radiobutton"
                        onChange={handleUserTypeChange}
                      >
                        <RadioButton
                          id="radio1-id"
                          value="company"
                          name="userType"
                          label={t("HPI.OpenContactCreate.Registration.Type2", {
                            defaultValue:
                              "Company user(enterprice businessess with multiple users/sites/locations, corporations)",
                          })}
                        />
                        <RadioButton
                          id="radio2-id"
                          value="individual"
                          name="userType"
                          label={t("HPI.OpenContactCreate.Registration.Type1", {
                            defaultValue:
                              "Single user(small or medium business with single user/site/location)",
                          })}
                        />
                      </RadioGroup>
                    </h5>
                    {userType && (
                      <>
                        <div className=" row rg-1 mt-3">
                          <div className=" col-md-6 mb-3">
                            <TextBox
                              className="txt"
                              id="firstname"
                              name="firstname"
                              required
                              placeholder={
                                t("HPI.OpenContactCreate.FirstName", {
                                  defaultValue: "First Name",
                                }) + " *"
                              }
                              value={formData.firstname}
                              onChange={(value, event) =>
                                handleInputChanges(value, event)
                              }
                              error={errorState["firstname"] ? true : false}
                              helperText={
                                errorState["firstname"]
                                  ? errorState["firstname"]
                                  : ""
                              }
                            />
                          </div>
                          <div className=" col-md-6 mb-3">
                            <TextBox
                              className="txt"
                              placeholder={
                                t("HPI.OpenContactCreate.LastName", {
                                  defaultValue: "Last Name",
                                }) + " *"
                              }
                              id="lastname"
                              name="lastname"
                              value={formData.lastname}
                              onChange={(value, event) =>
                                handleInputChanges(value, event)
                              }
                              error={errorState["lastname"] ? true : false}
                              helperText={
                                errorState["lastname"]
                                  ? errorState["lastname"]
                                  : ""
                              }
                            />
                          </div>
                        </div>
                        <div className=" row rg-1">
                          <div className=" col-md-6 mb-3">
                            <TextBox
                              className="txt"
                              placeholder={
                                t("HPI.OpenContactCreate.EmailAddress", {
                                  defaultValue: "Email address",
                                }) + " *"
                              }
                              id="email"
                              name="email"
                              value={formData.email}
                              onChange={(value, event) =>
                                handleInputChanges(value, event)
                              }
                              onBlur={(e) => handleBlur(e)}
                              error={!!errorState.email}
                              helperText={errorState.email}

                              // error={errorState["email"] ? true : false}
                              // helperText={
                              //   errorState["email"] ? errorState["email"] : ""
                              // }
                            />
                          </div>
                          <div className=" col-md-6 mb-3 ">
                            <Select
                              showSearch
                              onSearch={onSearchCountry}
                              required
                              options={optionCountry}
                              id="country"
                              name="country"
                              label={countryLabel}
                              placement="bottom"
                              helperTextVisibility="auto"
                              onClear={() => onClear("country")}
                              onChange={selectedOptionCountry}
                              value={optionCodeValue}
                              error={errorState["country"] ? true : false}
                              helperText={
                                errorState["country"]
                                  ? errorState["country"]
                                  : ""
                              }
                            />
                          </div>
                        </div>
                        <div className=" row rg-1">
                          <div className=" col-md-6 mb-3">
                            <TextBox
                              className="txt"
                              placeholder={
                                t("HPI.OpenContactCreate.Province", {
                                  defaultValue: "State/Province",
                                }) + " *"
                              }
                              value={formData.province}
                              id="province"
                              name="province"
                              onChange={(value, event) =>
                                handleInputChanges(value, event)
                              }
                              error={errorState["province"] ? true : false}
                              helperText={
                                errorState["province"]
                                  ? errorState["province"]
                                  : ""
                              }
                            />
                          </div>
                          <div className=" col-md-6 mb-3">
                            <TextBox
                              className="txt"
                              placeholder={
                                t("HPI.OpenContactCreate.City", {
                                  defaultValue: "City",
                                }) + " *"
                              }
                              value={formData.city}
                              id="city"
                              name="city"
                              onChange={(value, event) =>
                                handleInputChanges(value, event)
                              }
                              error={errorState["city"] ? true : false}
                              helperText={
                                errorState["city"] ? errorState["city"] : ""
                              }
                            />
                          </div>
                        </div>
                        <div className=" row rg-1">
                          <div className=" col-md-6 mb-3">
                            <TextBox
                              className="txt"
                              placeholder={
                                t("HPI.OpenContactCreate.AddressLine", {
                                  defaultValue: "Address Line",
                                }) + " *"
                              }
                              id="addressLine1"
                              name="addressLine1"
                              value={formData.addressLine1}
                              onChange={(value, event) =>
                                handleInputChanges(value, event)
                              }
                              error={errorState["addressLine1"] ? true : false}
                              helperText={
                                errorState["addressLine1"]
                                  ? errorState["addressLine1"]
                                  : ""
                              }
                            />
                          </div>
                          <div className=" col-md-6 mb-3">
                            <TextBox
                              className="txt"
                              placeholder={
                                t("HPI.OpenContactCreate.PostalCode", {
                                  defaultValue: "Postal Code",
                                }) + " *"
                              }
                              id="postalCode"
                              name="postalCode"
                              value={formData.postalCode}
                              onChange={(value, event) =>
                                handleInputChanges(value, event)
                              }
                              error={errorState["postalCode"] ? true : false}
                              helperText={
                                errorState["postalCode"]
                                  ? errorState["postalCode"]
                                  : ""
                              }
                            />
                          </div>
                        </div>
                        {userType === "company" && (
                          <>
                            <div className=" row rg-1">
                              <div className=" col-md-6 mb-3">
                                <TextBox
                                  className="txt"
                                  placeholder={
                                    t("HPI.OpenContactCreate.CompanyName", {
                                      defaultValue: "Company Name",
                                    }) + " *"
                                  }
                                  id="company"
                                  name="company"
                                  value={formData.company}
                                  onChange={(value, event) =>
                                    handleInputChanges(value, event)
                                  }
                                  error={errorState["company"] ? true : false}
                                  helperText={
                                    errorState["company"]
                                      ? errorState["company"]
                                      : ""
                                  }
                                />
                              </div>
                              <div className=" col-md-2 mb-2">
                                <Select
                                  showSearch
                                  onSearch={onSearchCode}
                                  // required
                                  options={optionCode}
                                  id="code"
                                  label={codeLabel}
                                  placement="bottom"
                                  helperTextVisibility="auto"
                                  onClear={() => onClear("code")}
                                  onChange={selectedOptionCode}
                                  value={optionCodeValue}
                                />
                              </div>
                              <div className=" col-md-4 mb-3">
                                <TextBox
                                  className="txt"
                                  placeholder={
                                    t("HPI.OpenContactCreate.Phonenumber", {
                                      defaultValue: "Phone Number",
                                    }) + " *"
                                  }
                                  id="phoneNumber"
                                  name="phoneNumber"
                                  value={formData.phoneNumber}
                                  onBlur={(e) => handleBlur(e)}
                                  onChange={(v: any, e) => {
                                    const value = getValidatedNumberInput(v, 15);
                                    if (value.length <= 15) {
                                      handleInputChanges(value, e);
                                    }
                                  }}

                                  error={!!errorState.phoneNumber}
                                  helperText={errorState.phoneNumber}

                                  // error={
                                  //   errorState["phoneNumber"] ? true : false
                                  // }
                                  // helperText={
                                  //   errorState["phoneNumber"]
                                  //     ? errorState["phoneNumber"]
                                  //     : ""
                                  // }
                                />
                              </div>
                            </div>
                            <div className=" row rg-1">
                              <div className=" col-md-12 mb-3">
                                <TextArea
                                  placeholder={
                                    t("HPI.OpenContactCreate.Notes", {
                                      defaultValue:
                                        "Note: Specify your company name and address",
                                    }) + " *"
                                  }
                                  value={formData.companyAddress}
                                  id="companyAddress"
                                  name="companyAddress"
                                  onChange={(value, event) =>
                                    handleTextAreaInput(value, event)
                                  }
                                  error={
                                    errorState["companyAddress"] ? true : false
                                  }
                                  helperText={
                                    errorState["companyAddress"]
                                      ? errorState["companyAddress"]
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </>
                    )}
                    {userType ? (
                      <div className="statement">
                        <div>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: t("HpPrivacyStatementLink", {
                                defaultValue: `<p>By completing and submitting this form you consent to the use of your data in accordance with HP's Privacy statement.&nbsp;<a target="_blank" href="http://www8.hp.com/us/en/privacy/privacy.html">Learn more about HP's privacy policy</a></p>`,
                              }),
                            }}
                          ></div>
                        </div>

                        <div className="register-button mr-6">
                          <Button
                            type="submit"
                            disabled={!isFormValid}
                            onClick={formHandleOnSubmit}
                          >
                            {t("HPI.OpenContactCreate.btnRegister", {
                              defaultValue: "Register",
                            })}
                          </Button>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          }
        />
      </Container>
      {/* <Footer /> */}
    </>
  );
};
export default SignUp;
